import generateTypes from '../../utils/generateTypes';

export const GET_INTEGRATION_PAST_HISTORY = generateTypes(
    'GET_INTEGRATION_PAST_HISTORY'
);
export const RESET_INTEGRATION_PAST_HISTORY = generateTypes(
    'RESET_INTEGRATION_PAST_HISTORY'
);
